import { render, staticRenderFns } from "./AddOrganization.vue?vue&type=template&id=0f4f596a&scoped=true&"
import script from "./AddOrganization.vue?vue&type=script&lang=js&"
export * from "./AddOrganization.vue?vue&type=script&lang=js&"
import style0 from "./AddOrganization.vue?vue&type=style&index=0&id=0f4f596a&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f4f596a",
  null
  
)

export default component.exports